import styled from "styled-components";
import ExclamationCircleIcon, {
  ExclamationCircleIconVariant,
} from "src/components/icons/ExclamationCircleIcon";

export enum AlertVariant {
  success = "success",
  warning = "warning",
  error = "error",
}

const AlertBox = styled.div`
  position: relative;
  border-radius: 8px;
  padding: 17px;
`;

const AlertBackground = styled.div<{ variant: AlertVariant }>`
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  background: ${(props) => {
    switch (props.variant) {
      case AlertVariant.success:
        return "var(--sea)";
      case AlertVariant.error:
        return "var(--watermelon)";
      case AlertVariant.warning:
        return "var(--orange)";
    }
  }};
  opacity: 0.16;
  border-radius: 8px;
`;

const SummaryP = styled.p`
  color: var(--husk);
  font-weight: 600;
  // Clear the default bottom margin on p tag
  margin-bottom: 0;
`;

const DescriptionP = styled.p`
  color: var(--husk);
  // Clear the default bottom margin on p tag
  margin-bottom: 0;
`;

const AlertBody = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
`;

const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
`;

const AlertText = styled.div``;

type Props = {
  summary: string;
  variant: AlertVariant;
  description?: string;
};

const getExclamationCircleIconVariant = (variant: AlertVariant) => {
  switch (variant) {
    case AlertVariant.error:
      return ExclamationCircleIconVariant.error;
    case AlertVariant.warning:
      return ExclamationCircleIconVariant.warning;
    default:
      return ExclamationCircleIconVariant.error;
  }
};

const Alert = (props: Props) => {
  return (
    <AlertBox>
      <AlertBackground variant={props.variant} />
      <AlertBody>
        {props.variant !== AlertVariant.success && (
          <IconWrapper>
            <ExclamationCircleIcon
              variant={getExclamationCircleIconVariant(props.variant)}
            />
          </IconWrapper>
        )}
        <AlertText>
          <SummaryP>{props.summary}</SummaryP>
          {props.description && (
            <DescriptionP>{props.description}</DescriptionP>
          )}
        </AlertText>
      </AlertBody>
    </AlertBox>
  );
};

export default Alert;
